import Bugsnag from '@bugsnag/browser';

import { environment } from 'environments/environment';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const appVersion = require('../../../../package.json').version;

export function initializeBugsnag() {
  const apiKey = environment.bugsnagKey;

  // eslint-disable-next-line
  console.log(`dashpivot web v${appVersion}`);

  const releaseStage = environment.bugsnagReleaseStage;

  Bugsnag.start({
    apiKey,
    appVersion,
    releaseStage,
  });
}
